import styled from 'styled-components';

export const SliderWrapper = styled.div`
  width: 100%;
`;
